<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Id" label="科目Id"></el-table-column>
        <el-table-column prop="CourseName" label="科目名称"></el-table-column>
        <el-table-column prop="DepartmentName" label="部门"></el-table-column>
        <el-table-column prop="Sort" label="排序"></el-table-column>
        <el-table-column prop="Remarks" label="备注"></el-table-column>

      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑科目" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">

          <el-form-item label="科目名称" prop="CourseName" required>
            <el-input v-model="editForm.CourseName"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
          <el-form-item label="排序" prop="Sort" required>
            <el-input v-model="editForm.Sort" type="number"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remarks">
            <el-input v-model="editForm.Remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增科目" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item label="科目名称" prop="CourseName" required>
            <el-input v-model="addForm.CourseName"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
          <el-form-item label="排序" prop="Sort" required>
            <el-input v-model="addForm.Sort" type="number"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remarks">
            <el-input v-model="addForm.Remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getSysCourseListPage, editSysCourse, addSysCourse, deleteSysCourse } from '../../api/modules/schedule-course';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CourseName: [{ required: true, message: '请输入科目名称', trigger: 'blur' }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CourseName: '',
        Sort: 1,
        Remarks: '',
        DepartmentId: 0,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CourseName: [{ required: true, message: '请输入科目名称', trigger: 'blur' }],
      },
      //新增界面数据
      addForm: {
        CourseName: '',
        Sort: 1,
        Remarks: '',
        DepartmentId: 0,
      },

      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
    };
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.page = 1;
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters
      }
      this.listLoading = true;
      testapi();
      getSysCourseListPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.PageSize = res.data.response.PageSize
        this.users = res.data.response.data
        this.listLoading = false
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      // 优先使用当前记录绑定的所属学校 ID，若无则使用当前页面统一选中的 ID 兜底
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editSysCourse(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deleteSysCourse(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg || "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        CourseName: '',
        Sort: 1,
        Remarks: '',
        DepartmentId: this.DepartmentId,
      };
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            addSysCourse(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
